// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bUmK","rightAdornment":"Header_rightAdornment__jS2HF"};